export class DateOnlyValueConverter {
  toView(value) {
    if (!value) {
      return;
    }
    return new Date(value).setHours(0, 0, 0, 0);
  }
}